import React from "react";
import { useSelector } from "react-redux";
import { ReduxControls } from "rhombus-react";

export default function DynamicCreativeToggle(props){
	const { disabled } = props;
	const numOfVersions = useSelector(state => state.creativeDetails?.numberOfVersions);
	// If there are any versions other than default, then disable the DynamicCreativeToggle
	const disableToggle = numOfVersions > 1 || disabled;

	return (
		<div className="e-form__control-wrapper half-width">
			<ReduxControls.Checkbox {...props} disabled={disableToggle} />
		</div>
	);
}

DynamicCreativeToggle.displayName = "DynamicCreativeToggle";

/*
	This is just a field config object that you can drop into social form field lists, and it should just work.

	You can also just spread it into a redux-form Field component like:
	```
		<Field {...isDynamic} />
	```
*/
export const isDynamic = {
	name: "isDynamic",
	label: "Enable Dynamic Versions",
	className: "custom-checkbox",
	component: DynamicCreativeToggle,
	useValue: true,
};
